/**
 * Main Application Component
 * Temporary: all routes redirect to Coming Soon except /modelo
 */

import { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { HomePage } from './pages/HomePage';
import { AppPage } from './pages/AppPage';
import { ModeloPage } from './pages/ModeloPage';
import { InternalTestingPage } from './pages/InternalTestingPage';
import { FavoritesPage } from './pages/FavoritesPage';
import { CookieConsent } from './components/CookieConsent';
import { initAnalytics } from './services/analyticsService';
import { captureUtmParams } from './services/utmCapture';
import { useAnalytics } from './hooks/useAnalytics';

function App() {
  // Initialize GA4 analytics and capture UTM params on mount
  useEffect(() => {
    captureUtmParams();
    initAnalytics();
  }, []);

  // Auto-track page views on route changes via hook
  useAnalytics();

  return (
    <>
    <Routes>
      {/* Coming soon landing */}
      <Route path="/" element={<HomePage />} />

      {/* Main translation app */}
      <Route path="/app" element={<AppPage />} />

      {/* Modelo dashboard stays live (password-protected) */}
      <Route path="/modelo" element={<ModeloPage />} />

      {/* Favorites management */}
      <Route path="/favorites" element={<FavoritesPage />} />

      {/* Internal testing tool (password-protected) */}
      <Route path="/testing" element={<InternalTestingPage />} />

      {/* Everything else → coming soon */}
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>

    {/* Cookie consent banner — renders at bottom of page */}
    <CookieConsent />
  </>
  );
}

export default App;
